/**
 * Per-group onboarding microservice toggles.
 *
 * Onboarding endpoints are split into groups (see
 * src/api/new-interfaces/live/api-dashboard.csv); each group has ONE independent Nexus
 * flag with a uniform payload `{ toggle: "on" | "off" }`. `"on"` routes that group's
 * endpoints to the new microservice (`api/new-interfaces`); `"off"` keeps them on the
 * legacy endpoints (`api/interfaces`).
 *
 * NOTE: the older combined `dis-flag-endpoint-onboarding` flag is intentionally kept
 * (not deleted) for backwards compatibility during the transition.
 */
export const ONBOARDING_GROUP_FLAGS = {
  GENERAL: "dis-flag-endpoints-general",
  API_INFO: "dis-flag-endpoints-api-info",
  MODULE_ACCESS_OTP: "dis-flag-endpoints-module-access-otp"
} as const;

export const KEY = {
  IT_VALIDATION_FIELD: "it-validation-field",
  FLAG_ENDPOINT_TRX_MICROSERVICES: "dis-flag-endpoint-trx-microservices",
  COMPANY_CUSTOM_FILTER_START_DATE: "dis-company-custom-filter-start-date",
  FLAG_ENDPOINT_CMS: "dis-flag-endpoint-cms",
  FLAG_ENDPOINT_ONBOARDING: "dis-flag-endpoint-onboarding",
  FLAG_ENDPOINT_ITR: "dis-flag-endpoint-itr",
  NEXUS_REFETCH_CONFIG: "dis-config-nexus-refetch",
  ...ONBOARDING_GROUP_FLAGS,
  FLAG_ENDPOINT_PAY: "pay-ffb-dashboard-flag-endpoint",
  NEW_ITR_FLOW: "dis-flag-new-itr-flow",
  ITR_MAKER_APPROVER_FLOW: "dis-flag-itr-maker-approver-flow",
  PAY_REFUND_FLAGS: "pay-refund-flags",
  PAY_HISTORY_V2: "pay-history-v2-flags",
  /** OnCall hardcode: force the BRI top-up account number on the payment page (ticket 86d4cfwun). */
  HARDCODE_BRI_ACCOUNT_TOPUP: "dis-flag-hardcode-bri-account-topup"
} as const;
